/* eslint-disable no-underscore-dangle */
import React from "react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Button, Dropdown, Input, InputGroup } from "rsuite";
import { Filter, Trash } from "lucide-react";

interface Tag {
    _id: string;
    label: string;
    color: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

interface FilterBarProps {
    tags: Tag[];
    onFilterChange: (filters: any) => void;
    onClearFilters: () => void;
}

const FilterBar = ({
    tags,
    onFilterChange,
    onClearFilters,
}: FilterBarProps) => {
    const [filters, setFilters] = React.useState({
        searchText: "",
        selectedTags: [] as string[],
        minTransactions: "",
        maxTransactions: "",
        dateRange: { start: "", end: "" },
    });

    const handleApplyFilters = () => {
        onFilterChange(filters);
    };

    const handleClearFilters = () => {
        setFilters({
            searchText: "",
            selectedTags: [],
            minTransactions: "",
            maxTransactions: "",
            dateRange: { start: "", end: "" },
        });
        onClearFilters();
    };

    return (
        <section className="flex flex-col mb-4">
            <div className="flex flex-wrap flex-row gap-2 justify-start">
                {/* Search Input */}
                <InputGroup className="w-full max-w-md">
                    <Input
                        placeholder="Search by name or phone"
                        value={filters.searchText}
                        onChange={value =>
                            setFilters({ ...filters, searchText: value })
                        }
                    />
                    <InputGroup.Addon>
                        <Filter size={16} />
                    </InputGroup.Addon>
                </InputGroup>

                {/* Tag Filter */}
                <Dropdown
                    // title={`Tags (${filters.selectedTags.length})`}
                    placement="topStart"
                    renderToggle={(props: any, ref: React.Ref<any>) => (
                        <button
                            type="button"
                            {...props}
                            ref={ref}
                            className="flex items-center gap-1 px-3 py-2 rounded bg-gray-100"
                        >
                            Tags ({filters.selectedTags.length})
                        </button>
                    )}
                >
                    {tags.map(tag => {
                        const isChecked = filters.selectedTags.includes(
                            tag._id
                        );

                        const toggleTag = () => {
                            const newTags = isChecked
                                ? filters.selectedTags.filter(
                                      id => id !== tag._id
                                  )
                                : [...filters.selectedTags, tag._id];
                            setFilters({ ...filters, selectedTags: newTags });
                        };

                        return (
                            <Dropdown.Item key={tag._id} onClick={toggleTag}>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={isChecked}
                                        onChange={toggleTag}
                                        onClick={e => e.stopPropagation()} // Prevent dropdown from closing
                                    />
                                    <span
                                        className="inline-block w-3 h-3 rounded-full"
                                        style={{ backgroundColor: tag.color }}
                                    />
                                    {tag.label}
                                </div>
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown>

                {/* Action Buttons */}
                <section className="flex gap-3">
                    <Button
                        appearance="primary"
                        className="bg-slate-800 hover:bg-slate-700"
                        onClick={handleApplyFilters}
                    >
                        Apply Filters
                    </Button>
                    <Button
                        appearance="ghost"
                        className="border-0 bg-red-400 flex items-center gap-1 text-red-50 hover:bg-red-500 hover:text-white"
                        onClick={handleClearFilters}
                    >
                        <Trash className="w-4 h-4" />
                        Clear
                    </Button>
                </section>
            </div>
        </section>
    );
};

export default FilterBar;
